import { render, staticRenderFns } from "./userBehaviorAnalysis.vue?vue&type=template&id=6e4d9e99&scoped=true"
import script from "./userBehaviorAnalysis.vue?vue&type=script&lang=js"
export * from "./userBehaviorAnalysis.vue?vue&type=script&lang=js"
import style0 from "./userBehaviorAnalysis.vue?vue&type=style&index=0&id=6e4d9e99&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4d9e99",
  null
  
)

export default component.exports